'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX_CLS = exports.PREFIX_CLS = 'ant-fullcalendar';


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/Constants.tsx
 ** module id = 204
 ** module chunks = 0
 **/